import { useMemo, useState } from "react";

import { Modal, TableCustom } from "../../../components/common";
import ListasModal from "../../../components/controls/ListasModal";
import EntidadesModal from "../../controls/EntidadesModal";
import { useListaEntidad } from "../../hooks/useListaEntidad";
import {TIPS} from "../../../consts/tips";

const InputListaMulti = ({ title, name, type, idField, data, setData, newItemFiller, className, disabled, memo, tipName = '' }) => {
    const [open, setOpen] = useState(false)
    const [adding, setAdding] = useState(false)

    const [items, ready] = useListaEntidad({
        listas: type === 'lista' ? [name] : undefined,
        entidades: type === 'entidad' ? [name] : undefined,
        memo,
    })

    const entities = useMemo(() => {
        if (!ready) return []
        else return Object.values(items[type === 'lista' ? 'listas' : 'entidades'][name])
    }, [name, items, ready])

    const filteredData = useMemo(() => {
        const unfound = [...data]
        const result = entities.filter(x => {
            for (let i = 0; i < unfound.length; i++) {
                const item = unfound[i]
                if (item[idField] === x.id) {
                    unfound.splice(i, 1)
                    return item.state !== 'r'
                }
            }
        })
        return result
    }, [data, entities])

    const onAdd = () => {
        setAdding(true)
    }

    const onAddConfirm = (id) => {
        if (data.find(x => x[idField] === id))
            setData(data.map(x => x[idField] === id ? {...x, state: 'o'} : x))
        else setData([...data, {
            id: -Date.now(),
            [idField]: id,
            state: 'a',
            ...newItemFiller,
        }])
        setAdding(false)
    }

    const onRemove = (item) => {
        const result = []
        data.forEach(x => {
            if (x[idField] === item.id) {
                if (x.state !== 'a') result.push({...x, state: 'r'})
            }
            else {
                result.push(x)
            }
        })
        setData(result)
    }

    const onClickModalExit = () => {
        setOpen(false)
    }

    const tableColumns = [
        { Header: 'Código', Cell: (data) => data.row.original.codigo??'N/A', accessor: 'id', width: '15%' },
        { Header: 'Nombre', accessor: 'nombre', width: '80%' },
        {
            id:'ar', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true,
            Header: (props) => disabled ? <div/> : (
                <div className='action'>
                    <div onClick={onAdd} className="link">
                        <span className="material-symbols-outlined" title="Nuevo">add</span>
                    </div>
                </div>
            ),
            Cell: (props) =>  disabled ? <div/> : (
                <div className='action'>
                    <div onClick={() => onRemove(props.row.original)} className="link">
                        <span className="material-symbols-outlined" title="Eliminar">delete</span>
                    </div>
                </div>
            ),
        },
    ]
    
    const inputText = filteredData.length < 1 ? '' : (filteredData[0].nombre + (filteredData.length > 1 ? '...' : '') )
    const modalTipName = tipName || TIPS.NAME.MODALS.ENTIDADES_MODAL;

    return <>
        <div className={className || "col-12 col-md-6 col-lg-4"}>
            <label htmlFor={name} className="form-label">{title}</label>
            <input
                name={name}
                type="text"
                placeholder=""
                className={disabled ? 'form-control input-entida link force-disabled' : 'form-control input-entidad link'}
                value={inputText}
                onClick={() => setOpen(true)}
                onKeyDown={(e) => { if (e.key === 'Enter' && !disabled) setOpen(true); }}
                readOnly
            />
        </div>

        <Modal
            onEscape={() => setOpen(false)}
            show={open}
            title={title}
            tipName={modalTipName}
            body={
                <div className="row">
                    <TableCustom
                        showFilterGlobal={false}
                        showDownloadCSV={false}
                        className='TableCustomBase'
                        columns={tableColumns}
                        data={filteredData}
                    />
                </div>
            }
            footer={<div className="width-100p f-align">
            <button className="btn back-button" data-dismiss="modal" onClick={() => setOpen(false)}>Volver</button>
            </div>}
        />

        {adding && (type === 'lista'
            ? <ListasModal
                {...{title, lista: name }}
                {...(tipName ? { tipName } : {})}
                onDismiss={() => { setAdding(false) }}
                onConfirm={onAddConfirm}
                showCode={true}
            />
            : <EntidadesModal
                {...{title, entidad: name}}
                {...(tipName ? { tipName } : {})}
                onDismiss={() => { setAdding(false) }}
                onConfirm={onAddConfirm}
                columns={[
                    { Header: 'Código', Cell: (data) => data.row.original.codigo??'N/A', accessor: 'id', width: '15%' },
                    { Header: 'Nombre', accessor: 'nombre', width: '80%' }
                ]}
            />
        )}
    </>
}

export default InputListaMulti
